import { render } from "./BuiltinLoginForm.vue?vue&type=template&id=d8bb9f08&scoped=true&ts=true"
import script from "./BuiltinLoginForm.vue?vue&type=script&lang=ts"
export * from "./BuiltinLoginForm.vue?vue&type=script&lang=ts"

import "./BuiltinLoginForm.vue?vue&type=style&index=0&id=d8bb9f08&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8bb9f08"]])

export default __exports__